import { User_ChatRoomView } from '@dinosband/bv-main-schema/dist/types'
import { Store as MainStore } from '@dinosband/bv-main-client'
import { BvSubscriber } from './manager/subscriber'

interface _ContextType {
  mainStore: MainStore
  chatRoomId: number
  userId: number
  isChannelRoom: boolean
}

export class User_ChatRoomViewSubscriber extends BvSubscriber<User_ChatRoomView> {

  context: _ContextType

  constructor (context: _ContextType, callback: (value: User_ChatRoomView | User_ChatRoomView[]) => void) {
    super(callback)
    this.context = context
  }

  protected async query () {
    if (this.context.isChannelRoom) {
      return
    }
    const result = await this.context.mainStore.readUser_ChatRoomViews([this.context.chatRoomId])
    return result?.filter((i) => i.userId !== this.context.userId) // 내 자신의 정보는 제외
  }

  protected async subscribe () {
    if (this.context.isChannelRoom) {
      return
    }
    return this.context.mainStore.subscribeOnUser_ChatRoomViewUpdated(this.context.chatRoomId, 0, (value) => {
      // this.context.store.updateUserReadMessageId(value)
      this.callback(value)
    })
  }

}
